import {
  initialState,
  Actions,
  State,
  ADD_PERIODIC_CHECK_FEEDBACK,
  ADD_PERIODIC_CHECK_FEEDBACK_ERROR,
  ADD_PERIODIC_CHECK_FEEDBACK_SUCCESS,
  RESET_ADD_PERIODIC_CHECK_FEEDBACK,
} from '../../types/periodic-check/add-feedback'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case ADD_PERIODIC_CHECK_FEEDBACK:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case ADD_PERIODIC_CHECK_FEEDBACK_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case ADD_PERIODIC_CHECK_FEEDBACK_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      }
    case RESET_ADD_PERIODIC_CHECK_FEEDBACK:
      return initialState
    default:
      return state
  }
}

export default reducers
